import { store } from 'quasar/wrappers';
import { computed, InjectionKey } from 'vue';
import {
  createStore,
  Store as VuexStore,
  useStore as vuexUseStore,
  // mapState as vuexMapState,
  // mapGetters as vuexMapGetters,
} from 'vuex';

import app from 'src/store/app';
import { AppInterface } from 'src/store/app/state';
import distribution from './distribution';
import { DistributionStateInterface } from 'src/store/distribution/state';
import loading from './loading';
import { LoadingStateInterface } from 'src/store/loading/state';
import socket from 'src/store/socket';
import { SocketStateInterface } from 'src/store/socket/state';
import statistics from 'src/store/statistics';
import { StatisticsStateInterface } from 'src/store/statistics/state';
import user from 'src/store/user';
import { UserInterface } from 'src/store/user/state';

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

export interface StateInterface {
  app: AppInterface;
  distribution: DistributionStateInterface;
  loading: LoadingStateInterface;
  statistics: StatisticsStateInterface;
  socket: SocketStateInterface;
  user: UserInterface;
}

// provide typings for `this.$store
// declare module '@vue/runtime-core' {
//   interface ComponentCustomProperties {
//     $store: VuexStore<StateInterface>;
//   }
// }

// provide typings for `useStore` helper
export const storeKey: InjectionKey<VuexStore<StateInterface>> =
  Symbol('vuex-key');

export default store(function (/* { ssrContext } */) {
  const Store = createStore<StateInterface>({
    modules: {
      app,
      distribution,
      loading,
      statistics,
      socket,
      user,
    },

    // enable strict mode (adds overhead!)
    // for dev mode and --debug builds only
    strict: !!process.env.DEBUGGING,
  });

  return Store;
});

export function useStore() {
  return vuexUseStore(storeKey);
}

export function mapGetters(namespace: string, keys: string[]) {
  const $store = useStore();
  return keys.reduce((getters, key) => {
    return {
      ...getters,
      [key]: computed(() => $store.getters[`${namespace}/${key}`]),
    };
  }, {});
}

export function mapState(namespace: string, keys: string[]) {
  const $store = useStore();
  return keys.reduce((getters, key) => {
    return {
      ...getters,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [key]: computed(() => $store.state[namespace][key]),
    };
  }, {});
}
